import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const slides = [{
  image: 'https://cdn.magicpatterns.com/uploads/bsNUFDDRvexi4TaBXDxPch/creativo_1.png',
  alt: 'Reto de 30 días para dejar de vivir al día'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/82kTov5kn2emkvHR8JbKR9/creativo_2.png',
  alt: 'Afirmaciones + ejercicios + plantillas listas para usar'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/kf8HTQ4GdMvSQc8tsoLEzu/creativo_3.png',
  alt: 'Antes: vivir al día / Después: saber exactamente a dónde va mi dinero'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/uFmE8Fbx9MnxhigDLgAitG/creativo_4.png',
  alt: '¿Lista para dejar de vivir al día?'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/5Vi1eTkpNrYDAgMaT9Ucng/creativo_5.png',
  alt: 'Descarga inmediata en tu celular'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/w24CRHavB2UcumEGkaNegU/creativo_6.png',
  alt: 'Descarga inmediata en tu celular'
}];
export function CreativeCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  // Auto-play functionality
  useEffect(() => {
    const timer = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(timer);
  }, [currentIndex]);
  const handleNext = () => {
    setDirection(1);
    setCurrentIndex(prevIndex => (prevIndex + 1) % slides.length);
  };
  const handlePrev = () => {
    setDirection(-1);
    setCurrentIndex(prevIndex => (prevIndex - 1 + slides.length) % slides.length);
  };
  const handleThumbnailClick = (index: number) => {
    setDirection(index > currentIndex ? 1 : -1);
    setCurrentIndex(index);
  };
  const slideVariants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  return <section className="py-16 md:py-20 bg-gradient-to-b from-white to-gray-50" data-id="element-1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        {/* Intro Text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 max-w-4xl mx-auto" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1e3a5f] mb-6" data-id="element-4">
            Tu plan de 30 días para tomar el control de tu dinero
          </h2>
          <div className="space-y-4 text-lg text-gray-600 leading-relaxed" data-id="element-5">
            <p data-id="element-6">
              <strong className="text-[#1e3a5f]" data-id="element-7">
                Finanzas Fáciles para Mujeres
              </strong>{' '}
              es una guía práctica de 30 días para dejar de vivir al día y
              empezar a tener el control de tu dinero, paso a paso.
            </p>
            <p data-id="element-8">
              En pocas semanas puedes{' '}
              <span className="text-[#1e3a5f] font-semibold" data-id="element-9">
                ver claro a dónde se va tu dinero
              </span>
              , detectar y recortar fugas sin castigarte y crear tu primer plan
              realista de ahorro.
            </p>
            <p className="text-base text-gray-500" data-id="element-10">
              El libro incluye un{' '}
              <strong data-id="element-11">reto de 30 días fácil de seguir</strong>, con
              afirmaciones, ejercicios y plantillas listas para usar, pensado
              para hacerlo en{' '}
              <strong data-id="element-12">5–10 minutos al día desde tu celular</strong>.
            </p>
          </div>
        </motion.div>

        {/* Modern Compact Carousel */}
        <div className="relative max-w-5xl mx-auto" data-id="element-13">
          {/* Main Display with Thumbnails Integrated */}
          <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6" data-id="element-14">
            {/* Thumbnail Strip - Left Side on Desktop, Bottom on Mobile */}
            <div className="order-2 md:order-1 md:col-span-2" data-id="element-15">
              <div className="flex md:flex-col gap-2 overflow-x-auto md:overflow-visible pb-2 md:pb-0 scrollbar-hide" data-id="element-16">
                {slides.map((slide, index) => <motion.button key={index} onClick={() => handleThumbnailClick(index)} initial={{
                opacity: 0,
                scale: 0.8
              }} animate={{
                opacity: 1,
                scale: 1
              }} transition={{
                duration: 0.3,
                delay: index * 0.05
              }} className={`relative flex-shrink-0 w-16 h-20 md:w-full md:h-24 rounded-lg overflow-hidden transition-all duration-300 ${index === currentIndex ? 'ring-3 ring-[#d4a574] shadow-lg scale-105 md:scale-100' : 'ring-1 ring-gray-200 opacity-60 hover:opacity-100 hover:ring-[#d4a574]/50'}`} aria-label={`Ver ${slide.alt}`} data-id="element-17">
                    <img src={slide.image} alt={slide.alt} className="w-full h-full object-cover" data-id="element-18" />
                    {index === currentIndex && <motion.div layoutId="activeIndicator" className="absolute inset-0 bg-[#d4a574]/10 border-2 border-[#d4a574]" transition={{
                  type: 'spring',
                  stiffness: 300,
                  damping: 30
                }} data-id="element-19" />}
                  </motion.button>)}
              </div>
            </div>

            {/* Main Carousel - Compact and Modern */}
            <div className="order-1 md:order-2 md:col-span-10" data-id="element-20">
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100" data-id="element-21">
                {/* Compact aspect ratio */}
                <div className="relative w-full aspect-[16/10]" data-id="element-22">
                  <AnimatePresence initial={false} custom={direction} data-id="element-23">
                    <motion.div key={currentIndex} custom={direction} variants={slideVariants} initial="enter" animate="center" exit="exit" transition={{
                    x: {
                      type: 'spring',
                      stiffness: 300,
                      damping: 30
                    },
                    opacity: {
                      duration: 0.2
                    }
                  }} className="absolute inset-0 flex items-center justify-center p-6 md:p-8" data-id="element-24">
                      <img src={slides[currentIndex].image} alt={slides[currentIndex].alt} className="max-w-full max-h-full w-auto h-auto object-contain drop-shadow-2xl" data-id="element-25" />
                    </motion.div>
                  </AnimatePresence>
                </div>

                {/* Sleek Navigation Arrows */}
                <button onClick={handlePrev} className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm hover:bg-white text-[#1e3a5f] p-2.5 rounded-full shadow-lg transition-all hover:scale-110 z-10 border border-gray-200/50" aria-label="Anterior" data-id="element-26">
                  <ChevronLeft className="w-5 h-5" data-id="element-27" />
                </button>
                <button onClick={handleNext} className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm hover:bg-white text-[#1e3a5f] p-2.5 rounded-full shadow-lg transition-all hover:scale-110 z-10 border border-gray-200/50" aria-label="Siguiente" data-id="element-28">
                  <ChevronRight className="w-5 h-5" data-id="element-29" />
                </button>

                {/* Modern Progress Indicator */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-1.5 z-10" data-id="element-30">
                  {slides.map((_, index) => <button key={index} onClick={() => handleThumbnailClick(index)} className="group relative" aria-label={`Ir a diapositiva ${index + 1}`} data-id="element-31">
                      <div className={`h-1 rounded-full transition-all duration-300 ${index === currentIndex ? 'w-8 bg-[#d4a574]' : 'w-1 bg-gray-300 group-hover:bg-gray-400 group-hover:w-4'}`} data-id="element-32" />
                    </button>)}
                </div>

                {/* Slide Counter Badge */}
                <div className="absolute top-4 right-4 bg-[#1e3a5f]/90 backdrop-blur-sm text-white text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-33">
                  {currentIndex + 1} / {slides.length}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-center mt-12 max-w-3xl mx-auto" data-id="element-34">
          <p className="text-lg text-gray-600 leading-relaxed" data-id="element-35">
            Está creado para{' '}
            <span className="text-[#1e3a5f] font-semibold" data-id="element-36">
              mujeres con ingresos variables
            </span>{' '}
            que hoy se sienten agobiadas por las cuentas y quieren pasar de la
            preocupación constante a{' '}
            <span className="text-[#1e3a5f] font-semibold" data-id="element-37">
              saber exactamente qué entra, qué sale y qué pueden construir con
              su dinero
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}